import { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { Box, Flex } from '@chakra-ui/react'
import PendingFaqDisplay from './PendingFaqDisplay'
import AnsweredFaqDisplay from './AnsweredFaqDisplay'
import { MdOutlineQuestionAnswer } from 'react-icons/md'
import { IoMdAddCircle } from 'react-icons/io';

import { useHistory, useLocation } from 'react-router-dom'
import {
  replaceDsrFeedContent,
  resetCreateNewDsrFeedPost,
  setDsrPages
} from '../../actions/dsr-actions'
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton'
import { getThisUserIdToken } from '../../../global/helpers/global-helpers'
import { getUserDetailsUsingDsrMembersArray } from '../../../profile/helpers/user-helper'
import useLaunchdeckModal from '../../../global/hooks/use-launchdeck-modal'

function DsrFaqDisplay({
    // Parent component
    dsrId,
    handleOpenSignupOrLoginModal,
    isPagePreviewMode,
    dsrProperties,
    isArchivedDsr,

    // Redux states
    createNewDsrFeedPostOutcome,
    dsrFeedContent,
    dsrPagesRedux,
    dsrStatusRedux,
    dsrTeamMembersRedux,
    isPublicDsrEnvironment,

    isRoomTemplate,
    isLockedRoom,
    isDsrAdmin,
    dsrFaqContent,
    // Actions
    resetCreateNewDsrFeedPost,
    replaceDsrFeedContent,
    setDsrPages
  }) {

  const history = useHistory();
  const location = useLocation();
  const { openLaunchdeckModal, closeLaunchdeckModal } = useLaunchdeckModal();
  const dsrTeamMembers = dsrTeamMembersRedux;

  const isDraftMode = (dsrStatusRedux === 'draft' || dsrStatusRedux === 'reverted-draft') ? true : false;

  const [faqArray, setFaqArray] = useState(dsrFaqContent)
  const [allowReorderFaq, setAllowReorderFaq] = useState("")
  const [altPageName, setAltPageName] = useState("")

  const thisUserId = getThisUserIdToken();
  const isDsrMember = getUserDetailsUsingDsrMembersArray(dsrTeamMembersRedux, thisUserId)

  useEffect(() => {
    if (dsrProperties?.altPageNames) {
      const { faq: faqAltPageName } = dsrProperties?.altPageNames || {};
      setAltPageName(faqAltPageName)
    }
  }, [dsrProperties])

  useEffect(() => {
    if (location.pathname) {
      const isLiveEdit = (location.pathname.startsWith("/edit")) ? true : false;
      const isDraftEdit = (location.pathname.startsWith("/draft")) ? true : false;
      if ((!!isLiveEdit && !isLockedRoom) || !!isDraftEdit) {
        if (!isPagePreviewMode) {
          setAllowReorderFaq(isDsrAdmin ? true : false)
        }
      }
    }
  }, [location.pathname])

  // Auto scroll to top
  const scrollToRef = useRef(false);

  useEffect(() => {
    if (scrollToRef.current) {
      const elementPosition = scrollToRef.current.getBoundingClientRect().top;
      const offset = 200; // Offset (200px)

      window.scrollTo({
        top: elementPosition - offset, // Scroll to the position minus the offset
        // behavior: 'smooth',
      });
    }
  }, []);

  useEffect(() => {
    if (dsrFaqContent) {
      setFaqArray(dsrFaqContent)
    }
  }, [dsrFaqContent]);


  // Rooms useEffect

  useEffect(() => {
    // Review if this useEffect is still required
    if (createNewDsrFeedPostOutcome) {
      const { updatedFaqQuestionArray, newPostCreated } = createNewDsrFeedPostOutcome || {};

      // Shows Question in FAQ subpage
      if (updatedFaqQuestionArray && Array.isArray(updatedFaqQuestionArray)) {
        setFaqArray(updatedFaqQuestionArray)
      }

      if (dsrFeedContent && dsrPagesRedux) {
        replaceDsrFeedContent([...dsrFeedContent, newPostCreated])

        const updatedPages = dsrPagesRedux.map((page) => {
          return page
        })

        //Shows post in feed content subpage
        setDsrPages(updatedPages)
        closeLaunchdeckModal()
      }
    }

    resetCreateNewDsrFeedPost()
  }, [createNewDsrFeedPostOutcome, dsrFeedContent, dsrPagesRedux]);


  const handleAskQuestionButton = () => {
    if (isRoomTemplate) {
      if (isLockedRoom === true) {
        openLaunchdeckModal("show-preview-page-action-modal")
      } else {
        // openLaunchdeckModal("create-faq-question-in-template")
        openLaunchdeckModal('create-question-in-faq-page', {})
      }
    } else if (isPublicDsrEnvironment) {
      if (isDsrMember) {
        history.push(`/dsr/${dsrId}`, {})

      } else {
        openLaunchdeckModal("show-signup-login-prompt")
      }
    } else {
      if (isPagePreviewMode) {
        openLaunchdeckModal("show-preview-page-action-modal")
      } else {
        openLaunchdeckModal('create-question-in-faq-page', {})
      }
    }
  }

  const handleClickCreateQuestionButton = () => {
    if (isRoomTemplate) {
      if (isLockedRoom === true) {
        openLaunchdeckModal("show-preview-page-action-modal")
      } else {
        // openLaunchdeckModal("create-faq-question-in-template")
        openLaunchdeckModal('create-question-in-faq-page', {})
      }

    } else if (isPublicDsrEnvironment) {
      handleOpenSignupOrLoginModal()
    } else {
      if (isPagePreviewMode) {
        openLaunchdeckModal("show-preview-page-action-modal")
      } else {
        openLaunchdeckModal('create-question-in-faq-page', {})
      }
    }
  }

  let answeredQuestions = faqArray ? faqArray.filter((question) => (!!question.answerTextContent)) : []
  let pendingQuestions = faqArray ? faqArray.filter((question) => (!question.answerTextContent)).sort((a, b) => new Date(b.questionCreatedAt) - new Date(a.questionCreatedAt)) : []

  const showAnsweredQuestions = answeredQuestions?.length > 0 ? true : false;
  const showPendingQuestions = pendingQuestions?.length > 0 ? true : false;
  const displayReorderButtons = (allowReorderFaq && answeredQuestions?.length > 1) ? true : false

  if (showAnsweredQuestions === false && showPendingQuestions === false) {
    return (
      <Box>
        <Box textAlign={["center", "center", "left", "left"]}>
          <Box
            color="brandDark.500"
            fontSize="1.5em"
            fontWeight="600"
            lineHeight="2.25em"
            ref={scrollToRef}
          >
            {altPageName || "Q&A"}
          </Box>
        </Box>
        <Flex mt='2em' justify='center' align='center' py='2.75em' border='1px solid #E5EAEF' rounded='0.5em' bg='white'>


          <Flex direction='column' justify='center' align='center'>

            <Box as={MdOutlineQuestionAnswer} color='brandDark.500' boxSize="3em" />

            <Flex fontWeight='400' align='center' textAlign='center' lineHeight='1.5em' fontSize='0.875em' color='gray.500' py='1.5em' px='1em'>
              {isArchivedDsr ? `No Q&A created` : `No questions yet. Get the first one going.`}
            </Flex>

            {!isArchivedDsr &&
              <Box whiteSpace='nowrap' >
                <Flex className='create-new-category-button' onClick={() => handleAskQuestionButton()}>
                  <Box className='create-new-category-button__button-text'>{isDraftMode ? 'Prepare a question' : 'Ask a question'}</Box>
                  <Box as={IoMdAddCircle} boxSize='1.25em' className='create-new-room-button__add-icon' />
                </Flex>
              </Box>
            }
          </Flex>
        </Flex>
      </Box>
    )


  } else {
    return (
      <>
        <Flex w='100%' justify='space-between' align='center' mb="1.25em" >
          <Box fontWeight="600" fontSize="1.5em" lineHeight="2em" color="brandDark.500">
            {altPageName || "Q&A"}
          </Box>
          {!isArchivedDsr && <LaunchdeckButton bg='brand.500' color='white' onClick={handleClickCreateQuestionButton} label=' Create question' />}
        </Flex>

        {showAnsweredQuestions &&
          <AnsweredFaqDisplay
            dsrId={dsrId}
            dsrTeamMembers={dsrTeamMembers}
            answeredQuestions={answeredQuestions}
            isRoomTemplate={isRoomTemplate}
            displayReorderButtons={displayReorderButtons}
            isPagePreviewMode={isPagePreviewMode}
          />
        }
        {showPendingQuestions &&
          <PendingFaqDisplay
            dsrId={dsrId}
            dsrTeamMembers={dsrTeamMembers}
            showPendingQuestions={showPendingQuestions}
            pendingQuestions={pendingQuestions}
            isRoomTemplate={isRoomTemplate}
            showButtonsSpacer={displayReorderButtons}
          />
        }

      </>
    );
  }
}


function mapStateToProps(state) {
  return {
    // Content
    dsrFeedContent: state.dsrFeedContent.results,
    dsrPagesRedux: state.setDsrPages.pages,
    dsrFaqContent: state.dsrFaqContent.results,
    dsrStatusRedux: state.dsrStatus.status,
    dsrTeamMembersRedux: state.dsrTeamMembers.members,

    // UX
    isPublicDsrEnvironment: state.publicDsrEnvironment.publicDsrEnv,
    isLockedRoom: state.lockedRoomCheck.isLockedRoom,
    isDsrAdmin: state.dsrAdmin.isDsrAdmin,
    createNewDsrFeedPostOutcome: state.createNewDsrFeedPostOutcome.results.data,
    // Templates
    isRoomTemplate: state.dsrTemplateId.isRoomTemplate,
  };
}


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      resetCreateNewDsrFeedPost,
      replaceDsrFeedContent,
      setDsrPages
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrFaqDisplay));
